import React, { useContext } from 'react';

import { AddressInput } from '@r1-frontend/unified-address-form';

import { FullBuyContext, TFullBuyContextProperties } from '~/src/features/full-buy/analytics/context';

export const OneLineAddressInput = () => {
    const { isVillage } = useContext<TFullBuyContextProperties>(FullBuyContext);

    return (
        <AddressInput withoutFlat={isVillage}/>
    );
};
